<script>
import { Scatter } from 'vue-chartjs'
import axios from "axios";

export default {
  extends: Scatter,
  mounted () {
    let green = '#337979'
    let red = '#cc3333'
    let url = "https://roxy.lab.ovaielo.se/api/v1/metrics?samples=168"
    //let url = "http://localhost:8080/api/v1/metrics?samples=168"
    // let blue = '#3333cc'

    axios.get(url).then(
      response => {
      let convert_to_ms = function(v) {
        return {x: v.x*1000, y: v.y}
      }
      this.renderChart({
      datasets: [
        {
          yAxisID: 'volt',
          label: 'förbrukning [V]',
          fill: false,
          showLine: true,
          lineTension: 0,
          borderColor: green,
          data: response.data.v_main.map(convert_to_ms)
        },
        {
          yAxisID: 'volt',
          label: 'motor [V]',
          fill: false,
          showLine: true,
          lineTension: 0,
          borderColor: red,
          data: response.data.v_engine.map(convert_to_ms)
        },
      ]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0
      },
      title: {
        text: "Roxy Monitoring",
        display: false
      },
      scales: {
        yAxes: [{
            id: 'volt',
            position: 'left',
            scaleLabel: {
              labelString: "Volt",
              display: true,
            },
            ticks: {
            }
        }],
        xAxes: [{
          type: "time",
          time: {
            unit: 'hour',
            displayFormats: {
              hour: 'MMM D, HH'
            }
          },
          distribution: 'series',
          ticks: {
             autoSkip: true,
             maxTicksLimit: 10
          }
        }]
      }
    })
  })
}}
</script>
